import React, { useState } from "react";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { User, HelpCircle, TriangleAlert, MessageCircle } from "lucide-react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
export default function AccountDeactivateChild() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    reason: "",
    withdrawn: "",
    confirmation: false,
    feedback: "",
  });
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("formData", formData);
  };

  return (
    <div>
      <div>
        <div className="flex items-center justify-center mt-5">
          Account Deactivation Request
        </div>
        <div className="flex items-center justify-center text-sm mt-2 mb-8 text-gray-300">
          Need Help?
        </div>
      </div>
      <div className="flex items-center justify-center">
        <Card className="w-full max-w-md p-8 bg-white !shadow-none rounded-2xl relative">
          <div className="px-6 py-4 bg-gray-50 rounded-xl text-xs">
            We're sorry to see you go. Please complete the form below to request
            deactivation of your 80eight account. Ensure all balances are
            withdrawn before submittion. This process is permanent
          </div>

          <form
            onSubmit={handleSubmit}
            className="[&_:invalid]:border-red-500 [&_:invalid]:ring-red-500"
          >
            <CardContent className="p-0 mt-6 w-full">
              <div>
                <div className="flex items-start gap-1 py-3">
                  <User />
                  <p>Personal Information</p>
                </div>

                <div className="py-2">
                  <Label htmlFor="fullName">Full Name *</Label>
                  <Input
                    type="text"
                    id="fullName"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    required
                  />
                </div>

                <div className="py-2">
                  <Label htmlFor="email">Registered Email *</Label>
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your@email.com"
                    required
                  />
                </div>

                <div className="py-2">
                  <Label htmlFor="phone">Phone Number *</Label>
                  <Input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+27821234567"
                    required
                  />
                </div>

                <div className="flex items-start gap-1 py-3">
                  <HelpCircle />
                  <p>Reason for Deactivation</p>
                </div>
                <div className="py-2">
                  <Label htmlFor="reason">Please select your reason *</Label>
                  <Input
                    type="text"
                    id="reason"
                    name="reason"
                    value={formData.reason}
                    onChange={handleChange}
                    placeholder="Type your reason here"
                    required
                  />
                </div>

                <div className="flex items-start gap-1 py-3">
                  <TriangleAlert />
                  <p>Final Confirmation</p>
                </div>
                <div className="py-2">
                  <Label>
                    Have you withdrawn all funds and assets from your account? *
                  </Label>
                  <div className="flex gap-10 py-3">
                    {["yes", "no"].map((val) => (
                      <label
                        key={val}
                        className="flex items-center space-x-2 cursor-pointer"
                      >
                        <input
                          type="radio"
                          name="withdrawn"
                          value={val}
                          checked={formData.withdrawn === val}
                          onChange={handleChange}
                          className="w-5 h-5 text-blue-600"
                          required
                        />
                        <span className="text-sm font-medium text-gray-700">
                          {val.charAt(0).toUpperCase() + val.slice(1)}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                <div className="py-2">
                  <input
                    type="checkbox"
                    id="confirmation"
                    name="confirmation"
                    checked={formData.confirmation}
                    onChange={handleChange}
                    className="w-3.5 h-3.5 mr-2"
                    required
                  />
                  <Label htmlFor="confirmation">
                    I confirm that I am the rightful owner of this account, all
                    funds have been withdrawn, and I understand this process is
                    irreversible.
                  </Label>
                </div>

                <div className="flex items-start gap-1 py-3">
                  <MessageCircle />
                  <p>Additional Feedback (Optional)</p>
                </div>
                <div className="py-2">
                  <Label htmlFor="feedback">Share your thoughts</Label>
                  <Textarea
                    id="feedback"
                    name="feedback"
                    value={formData.feedback}
                    onChange={handleChange}
                    placeholder="Share your thoughts..."
                    className="bg-white text-gray-900 placeholder:text-gray-500 focus-visible:ring-2 focus-visible:ring-blue-500"
                  />
                </div>

                <div className="flex justify-center w-full">
                  <div className="flex items-center justify-center gap-4">
                    <Button
                      disabled={false}
                      className={`py-5 px-16 text-sm font-normal text-white rounded-full bg-gradient-to-tr from-purple-500 to-rose-500 hover:opacity-90`}
                    >
                      Submit Deactivation Request
                    </Button>
                  </div>
                </div>
              </div>
            </CardContent>
          </form>
        </Card>
      </div>
    </div>
  );
}
